import { useCallback, useEffect, useState } from 'react';
import { searchConfigResponse } from '../Types/AdminType';
import { getAllSearchConfig } from '../Services/AdminService';
import SearchFilterConfigComponent from '../Components/SearchFilterConfigComponent';

function SearchFilterConfigPage() {
  const [adminData, setAdminData] = useState<searchConfigResponse[]>([]);

  const fetchConfig = useCallback(async () => {
    try {
      const response = await getAllSearchConfig();
      if (response.success) {
        setAdminData(response.data);
      }
    } catch (err) {
      console.error('Failed to load search config', err);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <div>
      <SearchFilterConfigComponent
        data={adminData}
        onEditSubmit={() => {}}
        onDeleteConfirm={() => {}}
        onRegisterSubmit={() => {}}
        menuName="Search Config"
        onChanged={fetchConfig}
      />
    </div>
  );
}

export default SearchFilterConfigPage;
